module.exports = __webpack_public_path__ + "img/1574563622.26426745.jpg";